import {FC, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import moment from 'moment'
import {SchedulerModel} from '../models/SchedulerModel'
import { DATE_FORMAT } from '../../../shared/constants'

type Props = {
  show: boolean
  onHide: () => void
  onConfirm: (folderName: string) => void
  scheduler: SchedulerModel | null
}

const TrySchedulerModal: FC<Props> = ({show, onHide, onConfirm, scheduler}) => {
  const intl = useIntl()
  const [executeDate, setExecuteDate] = useState(moment())

  const handleConfirm = () => {
    onConfirm(executeDate.format('YYMMDD'))
    onHide()
  }

  if (!scheduler) return null

  return (
    <Modal show={show} onHide={onHide} centered size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({id: 'Scheduler.TRY.TITLE'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row mb-3'>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.DESCRIPTION'})}
            </label>
            <p>{scheduler.name}</p>
          </div>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.FOLDER'})}
            </label>
            <p>{scheduler.folderType}</p>
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.FOLDERNAME'})}
            </label>
            <p>{scheduler.folderName}</p>
          </div>
          <div className='col-6'>
            <label className='form-label fw-bold'>
              {intl.formatMessage({id: 'Scheduler.TABLE.SETTING'})}
            </label>
            <p>{scheduler.setting}</p>
          </div>
        </div>
        <div className='separator my-5'></div>
        <div className='mb-3'>
          <label className='form-label '>
            {intl.formatMessage({id: 'Scheduler.TRY.EXECUTE_DATE'})} :({executeDate.format('YYMMDD')})
          </label>
          <input
            type='date'
            className='form-control'
            value={executeDate.format(DATE_FORMAT)}
            
            onChange={(e) => setExecuteDate(moment(e.target.value))}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={onHide}>
          {intl.formatMessage({id: 'GENERAL.CANCEL'})}
        </button>
        <button 
          type='button' 
          className='btn btn-primary' 
          onClick={handleConfirm}
          disabled={!executeDate}
        >
          {intl.formatMessage({id: 'Scheduler.TRY.CONFIRM'})}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default TrySchedulerModal
